module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/hojadeseguimiento/motivosconsulta/motivosconsultadetalle/motivosdetalle.component.scss
// module id = ./src/app/consulta/hojadeseguimiento/motivosconsulta/motivosconsultadetalle/motivosdetalle.component.scss
// module chunks = main